import { useLoaderData } from "react-router";
import { Map } from "~/components/ui/Map";
import { PageTitle } from "~/components/ui/PageTitle";
import { gameName } from "~/util/common";
import { useT } from "~/util/Lang";
import type { MetaFunc, OurLoaderArgs } from "~/util/Loaders";
import { logPageView } from "~/util/stats";
import { homePage } from "~/util/titles";
import { useSetUrlQuery, useUrlQuery } from "~/util/UrlUtils";

async function makeData(la: OurLoaderArgs) {
  // Log
  logPageView(la);
  //
  return {};
}

type LoaderData = Awaited<ReturnType<typeof makeData>>;

export const loader = async (_la: OurLoaderArgs) => {
  const data = await makeData(_la);
  return { ...data, authUser: _la.req.sess?.user };
};

export const meta: MetaFunc<LoaderData> = (cx) => {
  return {
    title: `${cx.t({ en: "World Map", ru: "Карта мира" })} - ${homePage(
      cx.realm
    )}`,
    description: cx.t({
      en: `${gameName(cx.realm.game)} World Map`,
      ru: `Карта мира${gameName(cx.realm.game)}`,
    }),
    ogTitle: `Lineage 2 World Map`,
  };
};

export default function MapPage() {
  const data = useLoaderData() as LoaderData;
  const t = useT();
  const mapTitle = t({ en: "World Map", ru: "Карта мира" });
  const urlQuery = useUrlQuery();
  const setUrlQuery = useSetUrlQuery();
  const spawns: { x: number; y: number }[] = (urlQuery["loc"] ?? "")
    .split(",")
    .map((pair) => {
      const arr = pair.split(":", 2).map((a) => parseInt(a) || 0);
      const x = arr[0] ?? 0;
      const y = arr[1] ?? 0;
      return { x, y };
    });

  return (
    <div className="content">
      <PageTitle>{mapTitle}</PageTitle>

      <Map
        fullscreen={true}
        spawns={spawns.map((spawn) => ({ pos: [spawn] }))}
        onClick={(point) => {
          setUrlQuery(
            { ...urlQuery, loc: `${point.x}:${point.y}` },
            { preventScrollReset: true }
          );
        }}
      />
    </div>
  );
}
